exports.baseURL = "https://swo.drfit.site/";
exports.key = "133e1f54e11f90ef6d7a";
exports.projectName = "Vola Party";
